import { Input, Modal } from "antd";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  selectError,
  selectInfoWarranty,
  selectIsValidated,
  validateWarrantyInfo,
  warrantyActions,
} from "../../redux/reducers/slice/warranty";
import ResultRegisterWarranty from "./resultRegister";

const ActivatedWarranty = (props: any) => {
  // const {} = props;
  const dispatch = useDispatch();
  const isValidated = useSelector(selectIsValidated);
  const infoWarranty = useSelector(selectInfoWarranty);
  const error = useSelector(selectError);
  const [visible, setVisible] = useState(
    infoWarranty ? infoWarranty?.is_activated : false
  );
  const [keyWord, setKeyWord] = useState("");

  const handleValidate = async () => {
    await dispatch(validateWarrantyInfo(infoWarranty?.uid || "", keyWord));
  };

  return (
    <>
      {isValidated ? (
        <ResultRegisterWarranty {...props} />
      ) : (
        <Modal
          width={400}
          className="confirm-otp"
          title="Xác nhận"
          visible={visible}
          cancelText="Đóng"
          onCancel={() => {
            setVisible(false);
            dispatch(warrantyActions.resetInfoWarranty());
            props.setStep(1);
          }}
          okText="Xác nhận"
          onOk={handleValidate}>
          <label className="main-content">
            Quý khách vui lòng nhập số điện thoại hoặc email đã đăng kí để xác
            nhận
          </label>

          <div className="confirm-otp__input">
            <Input
              className="input-input main-content"
              onChange={(e) => setKeyWord(e.target.value)}
            />
            <span className="main-content" style={{ color: "red" }}>
              {error}
            </span>
          </div>
        </Modal>
      )}
    </>
  );
};
export default ActivatedWarranty;
